"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeType = void 0;
var FeeType;
(function (FeeType) {
    FeeType["ORIGINATION_FEE"] = "ORIGINATION_FEE";
    FeeType["APPRAISAL_FEE"] = "APPRAISAL_FEE";
    FeeType["CREDIT_REPORT_FEE"] = "CREDIT_REPORT_FEE";
    FeeType["FLOOD_CERTIFICATION_FEE"] = "FLOOD_CERTIFICATION_FEE";
    FeeType["RECORD_RETENTION_FEE"] = "RECORD_RETENTION_FEE";
    FeeType["UNCATEGORIZED_FEE"] = "UNCATEGORIZED_FEE";
})(FeeType = exports.FeeType || (exports.FeeType = {}));
